import { Group } from './group';

export class GroupCommand {
    name: string;
    image?: {
        id: number;
    };
    is_favourite: boolean;

    constructor(group: Group) {
        this.name = group.name;
        this.is_favourite = group.isFavourite;
        if (group.image) {
            this.image = {
                id: parseInt(group.image.id),
            };
        }
    }
}
